/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Sync_People_AllInputs */

const cs_calendar_sync_people_all = /** @type {(inputs: Calendar_Sync_People_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všichni viditelní`)
};

const en_calendar_sync_people_all = /** @type {(inputs: Calendar_Sync_People_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone visible`)
};

/**
* | output |
* | --- |
* | "Everyone visible" |
*
* @param {Calendar_Sync_People_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_people_all = /** @type {((inputs?: Calendar_Sync_People_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_People_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_people_all(inputs)
	return cs_calendar_sync_people_all(inputs)
});